import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KeyboardService } from '@freelancer/keyboard';
import { StickyBehaviour, StickyPosition } from '@freelancer/ui/sticky';
import type { Observable } from 'rxjs';
import {
  StickyFooterBackgroundColor,
  StickyFooterPosition,
} from './sticky-footer.types';

@Component({
  selector: 'fl-sticky-footer',
  template: `
    <div
      *ngIf="position === StickyFooterPosition.FIXED"
      class="StickyFooterContainer"
      [attr.data-full-width]="fullWidth"
      [flSticky]="true"
      [flStickyStatic]="stickyStatic"
      [flStickyPosition]="StickyPosition.BOTTOM"
      [flStickyBehaviour]="StickyBehaviour.ALWAYS"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>

    <ng-container *ngIf="position === StickyFooterPosition.ABSOLUTE">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>

    <ng-template #content>
      <div
        class="StickyFooter"
        [class.IsKeyboardOpen]="isKeyboardOpen$ | flAsync"
        [class.IsHidden]="(isKeyboardOpen$ | flAsync) && hideOnKeyboardActive"
        [attr.data-position]="position"
        [attr.data-box-shadow]="boxShadow"
        [attr.data-space-between]="spaceBetween"
        [attr.data-background-color]="backgroundColor"
      >
        <ng-content></ng-content>
      </div>
    </ng-template>
  `,
  styleUrls: ['./sticky-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyFooterComponent implements OnInit {
  StickyFooterPosition = StickyFooterPosition;
  StickyBehaviour = StickyBehaviour;
  StickyPosition = StickyPosition;

  isKeyboardOpen$: Observable<boolean>;

  @Input() position = StickyFooterPosition.ABSOLUTE;
  @Input() boxShadow = true;
  @Input() stickyStatic = false;
  @Input() fullWidth = true;
  @Input() spaceBetween = false;

  // Hide when virtual keyboard is open
  // Note: This only for native apps
  @Input() hideOnKeyboardActive = true;
  @Input() backgroundColor = StickyFooterBackgroundColor.DEFAULT;

  constructor(private keyboardService: KeyboardService) {}

  ngOnInit(): void {
    this.isKeyboardOpen$ = this.keyboardService.isOpen();
  }
}
